
const columns = [
  {label: "Bank", accessor: "bank"},
  {label: "Nazwa Oferty", accessor: "nazwaOferty"},
  {label: "Nazwa pakietu", accessor:"nazwaPakietu"},
 // {label: "Maxltv", accessor:"maxLTV"},
  {label: "Oprocentowanie" , accessor:"marża"},
  {label: "Marża 1 rok", accessor:"marża1Rok"},
  //{label: "Kwota Brutto", accessor:"brutto"},
  {label: "Przyjęty Wibor/Wiron", accessor:"wibor"},
  {label: "Oprocentowanie", accessor:"oprocentowanieStaleCzZmienne"},
 // {label: "Rata równa i malejąca", accessor:"rataRówna"},
  {label: "Oprocentowanie stałe na ile lat", accessor:"staleNa5czy10Lat"},
  {label: "Marża po okresie stałego oprocentowania", accessor:"marzaPoOkresieStalego"},
  {label: "RRSO(nie uwzględnia dopłat z BK2%)", accessor:"RRSO"},
  {label: "Prowizja w %", accessor:"prowizja"},
  {label: "Rata przejściowa", accessor:"rataPrzejsciowa"},
  {label: "Dopłata BK2% do raty", accessor:"dopłata"},
  {label: "Rata docelowa(dlaBK2% po dopłatach)", accessor:"rataDocelowa"},
  {label: "Całkowity koszt tylko odsetek minus dopłaty z BK2%", accessor:"całkowityKoszt"},
  {label: "Suma dopłat w BK2%", accessor:"sumaDopłat"},
  {label: "Całkowity koszt reszty - prowizja, ubezpieczenia, wyceny itd", accessor:"całkowityKosztInne"},
  //{label: "Całkowity koszt wszystkiego \n bez zmiany oprocentowania", accessor:"całkowityKosztWszystkiego"},
  //{label: "Całkowity koszt przejścia z \n oprocentowania stałego na zmienne", accessor:"całkowityKosztOprStałe"},
  {label: "Wibor 3M/6M lub WIRON 1M", accessor:"wibor3mCzy6m"},
  {label: "Ubezpieczenie nieruchomości - Koszt miesięczny", accessor:"ubezpieczenieNieruchomosciskładka"},
  {label: "Na jaki okres", accessor:"naJakiOkresUbN"},
  {label: "Koszt z banku", accessor:"kosztZBanku"},
  {label: "Ubezpieczenie Nieruchomosci pełny koszt", accessor: "ubNieruchomościpełnykoszt"},
  {label: "Rezygnacja z ubezpieczenia", accessor:"rezygnacjaZUB"},
  {label: "Koszt ubezpieczenie na życie w %", accessor:"ubezpieczenieNaŻycie"},
  {label: "Składka jednorazowa czy płatna miesięcznie", accessor:"ubezpieczenieNaŻycieJakaSkładka"},
  {label: "Ubezpieczenie na życie", accessor:"ubezpieczenieNaŻycieSkładka"},
  {label: "Ubezpieczenie na życie - pełny koszt", accessor: "ubezpieczenieNaŻyciePełnyKoszt"},
  {label: "Okres na jaki wymagane jest ubezpieczenie w miesiącach", accessor:"okresUbZycie"},
  {label: "Czy jest obowiązkowe?", accessor:"czyObowiązkowe"},
  {label: "Rezygnacja z ubezpieczenia", accessor:"rezygnacjaZUb"},
  {label: "Ubezpieczenie od utraty pracy w %", accessor:"ubezpieczenieOdUtratyPracy"},
  {label: "Okres ubezpieczenia od utraty pracy", accessor:"okresUbezpieczeniaOdUtratyPracy"},
  {label: "Wyliczona składka ubezpieczenia od utraty pracy", accessor:"ubezpieczenieOdUtratyPracyKoszt"},
  {label: "Wcześniejsza spłata przez pierwsze 3 lata w %", accessor:"wcześniejszaSpłata"},
  {label: "Wycena za mieszkanie", accessor:"wycenaMieszkanie"},
  {label: "Wycena za dom", accessor:"wycenaDom"},
  {label: "Wycena za działkę", accessor:"wycenaDzialka"},
  //{label: "Inne", accessor:"inne"},
  //{label: "Inne", accessor:"inne2"},
 // {label: "Harmonogram", accessor:"harmonogram"},
  {label: "Konto osobiste", accessor:"kontoOsobiste"},
  {label: "Czy konto wymagane?", accessor:"czyObowiazkowe"},
  {label: "Koszt prowadzenia konta", accessor:"kosztProwadzenia"},
  {label: "Rezygnacja z konta?", accessor:"rezygnacjaZKonta"},
  {label: "Komentarz do konta", accessor:"komentarzDoKonta"},
  {label: "Karta Kredytowa", accessor:"kartaKredytowa"},
  {label: "Czy KK obowiązkowa", accessor:"czyObowiązkowa"},
  {label: "Koszt karty kredytowej", accessor:"kosztKarty"},
  {label: "Rezygnacja z KK", accessor:"rezygnacjaZKarty"},
  {label: "Komentarz do KK", accessor:"komentarzDoKartyKedytowej"},
  
]


const tableData = [
    {
        id: 1,
        bank:"BNP Paribas",
        nazwaOferty:"Kredyt hipoteczny",
        nazwaPakietu:"Pakiet H1",
        maxLTV	:	0.8,
        kwotaKredytuOd	:	100000,
        kwotaKredytuDo	: 4000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	: "",
        marża1Rok	:"",
        wibor:6.92,
        RRSO:"",
        oprocentowanieStaleCzZmienne: "Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	: 5,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt: 0,
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.3	,
        komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        ubezpieczenieNieruchomosciskładka:"",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:0,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.000725,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"tak",
        rezygnacjaZUb	:	0.6	,
        ubezpieczenieOdUtratyPracy: 0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400	,
        wycenaDom	:	700	,
        wycenaDzialka	:	400	,
        inne	:"",
        inne2:"",
        
      },
      
      {
        id: 2,
        bank:"BNP Paribas",
        nazwaOferty:"Kredyt hipoteczny",
        nazwaPakietu:"Pakiet H2",
        maxLTV	:	0.8,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	:4000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.92,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.3	,
        komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.0004,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"tak",
        rezygnacjaZUb	:	0.6	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400	,
        wycenaDom	:	700	,
        wycenaDzialka	:	400	,
        inne	:"",
        inne2:"",
        
      },
      
      {
        id: 3,
        bank:"BNP Paribas",
        nazwaOferty:"Kredyt hipoteczny",
        nazwaPakietu:"Pakiet H1",
        maxLTV	:	0.8,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	:4000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.92,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	10,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.3	,
        komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.000725,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"tak",
        rezygnacjaZUb	:	0.6	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400	,
        wycenaDom	:	700	,
        wycenaDzialka	:	400	,
        inne	:"",
        inne2:"",
      },
      
      {
        id: 4,
        bank:"BNP Paribas",
        nazwaOferty:"Kredyt hipoteczny",
        nazwaPakietu:"Pakiet H2",
        maxLTV	:	0.8,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	:4000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.92,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	10,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.3	,
        komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.0004,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"tak",
        rezygnacjaZUb	:	0.6	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400	,
        wycenaDom	:	700	,
        wycenaDzialka	:	400	,
        inne	:"",
        inne2:"",
        
      },
      
      {
      id:5,
      bank:'BNP Paribas',
      nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie na 5 lat",
      nazwaPakietu	:"Oferta Standard",
      maxLTV	:	0.8	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:4000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.92,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.3	,
      komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:'brak',
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	"brak"	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400	,
      wycenaDom	:	700	,
      wycenaDzialka	:	400	,
      inne	:"",
      inne2:"",
},

{
  id:6,
  bank:'BNP Paribas',
  nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie na 10 lat",
  nazwaPakietu	:"Oferta standard",
  maxLTV	:	0.8	,
  kwotaKredytuOd	:	100000	,
  kwotaKredytuDo	:4000000,
  wymaganeZarobkiNetto	:0,
  dataOfertyOd	:"",
  dataOfertyDo	:"",
  marża	:"",
  marża1Rok	:"",
  wibor:6.92,
  RRSO:"",
  oprocentowanieStaleCzZmienne	:"Stałe",
  rataRówna : 0,
  staleNa5czy10Lat	:	10,
  marzaPoOkresieStalego	:"",
  prowizja	:	2	,
  rataPrzejsciowa	:"",
  rataDocelowa	:"",
  całkowityKoszt:"",
  wibor3mCzy6m	:"6m",
  kontoOsobiste	:"tak",
  czyObowiazkowe	:"nie",
  kosztProwadzenia	:"",
  rezygnacjaZKonta	:	0.3	,
  komentarzDoKonta	:"karta debetowa z wpływem 2500zł",
  kartaKredytowa	:"",
  czyObowiązkowa	:"",
  kosztKarty	:"",
  rezygnacjaZKarty	:"",
  komentarzDoKartyKedytowej	:"",
  ubezpieczenieNieruchomosci:"Tak",
  naJakiOkresUbN	:"pełny",
  kosztZBanku	:	0,
  ubNieruchomościpełnykoszt:"",
  rezygnacjaZUB	:'brak',
  ubezpieczenieNaŻycie	:	0,
  ubezpieczenieNaŻycieJakaSkładka: "Brak",
  ubezpieczenieNaŻycieSkładka:"",
  ubezpieczenieNaŻyciepełnyKoszt:"",
  okresUbZycie	:0,
  czyObowiązkowe	:"nie",
  rezygnacjaZUb	:	"brak"	,
  ubezpieczenieOdUtratyPracy:0,
  okresUbezpieczeniaOdUtratyPracy:0,
  rezygnacjaZUbodUtratyPracy:"",
  wcześniejszaSpłata	:	0	,
  wycenaMieszkanie	:	400	,
  wycenaDom	:	700	,
  wycenaDzialka	:	400	,
  inne	:"",
  inne2:"",
},

      {
        id:7,
        bank:"Millennium",
        nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	20000	,
        kwotaKredytuDo	: 5000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5	,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.5	,
        komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0.0003,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,//pełny
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.5	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	499	,
        wycenaDom	:	799	,
        wycenaDzialka	:	499	,
        inne	:"wiekszych miast powyżej 900k 20%",
        inne2:"	dla mniejszyhc 650k 	"
      },
     
      {
        id:8,
        bank:"Millennium",
        nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie bez konta",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	20000	,
        kwotaKredytuDo	: 5000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5	,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.5	,
        komentarzDoKonta	:"",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.00075/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0.0003,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,//pełny
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.5	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	499	,
        wycenaDom	:	799	,
        wycenaDzialka	:	499	,
        inne	:"wiekszych miast powyżej 900k 20%",
        inne2:"	dla mniejszyhc 650k 	"
      },
    
      
      

      {
        id:9,
        bank:'PKOBP',
        nazwaOferty:"	Kredyt hipoteczny - zmienne oprocentowanie",
        nazwaPakietu	:"Własny kąt Hipoteczny",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	20000	,
        kwotaKredytuDo	: 5000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:8.54,
        marża1Rok	:1.1,
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Zmienne",
        rataRówna : 0,
        staleNa5czy10Lat	:	'',
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.5	,
        komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.0008/12	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0.0033276,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,//pełny
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.5	,
        ubezpieczenieOdUtratyPracy:3.25,
        okresUbezpieczeniaOdUtratyPracy:48,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400	,
        wycenaDom	:	700	,
        wycenaDzialka	:	400	,
        inne	:"",
        inne2:""
      },


      {
        id:10,
        bank:'ING',
        nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie",
        nazwaPakietu	:"Lekka rata",
        maxLTV	:	0.8	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 1500000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:1.59,
        prowizja	:	1.5	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.4	,
        komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.000096	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0.00035,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.5	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	462	,
        wycenaDom	:	748	,
        wycenaDzialka	:	462	,
        inne	:"",
        inne2:""
      },

      {
        id:11,
        bank:'ING',
        nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie",
        nazwaPakietu	:"Łatwy Start",
        maxLTV	:	0.8	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 1500000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:1.69,
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.4	,
        komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	:"",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:"pełny",
        kosztZBanku	:	0.000096	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0.00035,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:36,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.5	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	462	,
        wycenaDom	:	748	,
        wycenaDzialka	:	462	,
        inne	:"",
        inne2:""
      },

      {
        id:12,
        bank:'Santander',
        nazwaOferty:"	Kredyt hipoteczny",
        nazwaPakietu	:"Klient Standard",
        maxLTV	:	1	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:6.99,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"nie",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	0.2	,
        komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
        rezygnacjaZKarty	:0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	:60,
        kosztZBanku	:	0.000096	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.00035,
        ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:60,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	0.2	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },


      {
        id:13,
        bank:'PEKAOSA',
        nazwaOferty:"Oferta specjalna bez CPI",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:7.03,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:"",
        prowizja	:	1.99	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa",
        rezygnacjaZKarty	: 0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        ubNieruchomościpełnykoszt:"",
        kosztZBanku	:	0.001/12	,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0,
        ubezpieczenieNaŻycieJakaSkładka: "Brak",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },

      {
        id:14,
        bank:'PEKAOSA',
        nazwaOferty:"Oferta specjalna z CPI",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:7.03,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa",
        rezygnacjaZKarty	: 0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        ubNieruchomościpełnykoszt:"",
        kosztZBanku	:	0.001/12	,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie:	0.019656,
        ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:48,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },


      {
        id:15,
        bank:'PEKAOSA',
        nazwaOferty:"Oferta specjalna bez CPI",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:7.03,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Zmienne",
        rataRówna : 0,
        staleNa5czy10Lat	:	"",
        marzaPoOkresieStalego	:"",
        prowizja	:	1.99	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa",
        rezygnacjaZKarty	: 0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        ubNieruchomościpełnykoszt:"",
        kosztZBanku	:	0.001/12	,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0,
        ubezpieczenieNaŻycieJakaSkładka: "Brak",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	: 0,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },

      {
        id:16,
        bank:'PEKAOSA',
        nazwaOferty:"Oferta specjalna CPI bez prowizji",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor:7.03,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Zmienne",
        rataRówna : 0,
        staleNa5czy10Lat	:	"",
        marzaPoOkresieStalego	:"",
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa",
        rezygnacjaZKarty	: 0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        ubNieruchomościpełnykoszt:"",
        kosztZBanku	:	0.001/12	,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.019656,
        ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },

      {
        id:17,
        bank:'PEKAOSA',
        nazwaOferty:"Oferta specjalna z CPI i prowizją",
        nazwaPakietu	:"",
        maxLTV	:	0.9	,
        kwotaKredytuOd	:	100000	,
        kwotaKredytuDo	: 20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:"",
        marża1Rok	:"",
        wibor: 7.03,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Zmienne",
        rataRówna : 0,
        staleNa5czy10Lat	:	"",
        marzaPoOkresieStalego	:"",
        prowizja	:	1.99	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"6m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"Karta kredytowa",
        rezygnacjaZKarty	: 0.1,
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        ubNieruchomościpełnykoszt:"",
        kosztZBanku	:	0.001/12	,
        rezygnacjaZUB	:0.1,
        ubezpieczenieNaŻycie	:	0.019656,
        ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	: 48,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	480	,
        wycenaDom	:	780	,
        wycenaDzialka	:	480	,
        inne	:"",
        inne2:""
      },
      {
        id:18,
        bank:'CITIHandlowy',
        nazwaOferty:"Kredyt Mieszkaniowy z oprocentowaniem okresowo stałym",
        nazwaPakietu	:"",
        maxLTV	:	0.8	,
        kwotaKredytuOd	:200000	,
        kwotaKredytuDo	:20000000,
        wymaganeZarobkiNetto	:0,
        dataOfertyOd	:"",
        dataOfertyDo	:"",
        marża	:8.45,
        marża1Rok	:"",
        wibor:6.92,
        RRSO:"",
        oprocentowanieStaleCzZmienne	:"Stałe",
        rataRówna : 0,
        staleNa5czy10Lat	:	5,
        marzaPoOkresieStalego	:2.19,
        prowizja	:	0	,
        rataPrzejsciowa	:"",
        rataDocelowa	:"",
        całkowityKoszt:"",
        wibor3mCzy6m	:"3m",
        kontoOsobiste	:"tak",
        czyObowiazkowe	:"tak",
        kosztProwadzenia	:"",
        rezygnacjaZKonta	:	""	,
        komentarzDoKonta	:"Konto ROR z wpływem",
        kartaKredytowa	:"",
        czyObowiązkowa	:"",
        kosztKarty	:"",
        rezygnacjaZKarty	: "",
        komentarzDoKartyKedytowej	:"",
        ubezpieczenieNieruchomosci:"Tak",
        naJakiOkresUbN	: "pełny",
        kosztZBanku	:	0.000049	,
        ubNieruchomościpełnykoszt:"",
        rezygnacjaZUB	:"",
        ubezpieczenieNaŻycie	:	0,
        ubezpieczenieNaŻycieJakaSkładka: "Brak",
        ubezpieczenieNaŻycieSkładka:"",
        ubezpieczenieNaŻyciepełnyKoszt:"",
        okresUbZycie	:0,
        czyObowiązkowe	:"nie",
        rezygnacjaZUb	:	""	,
        ubezpieczenieOdUtratyPracy:0,
        okresUbezpieczeniaOdUtratyPracy:0,
        rezygnacjaZUbodUtratyPracy:"",
        wcześniejszaSpłata	:	0	,
        wycenaMieszkanie	:	400,
        wycenaDom	:	600	,
        wycenaDzialka	:	""	,
        inne	:"",
        inne2:""
      },
      
      
      {
      id:19,
      bank:'BOŚ Bank',
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:1.99,
      prowizja	:	2.2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:	0.00095/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	3	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },


    
    {
      id:20,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient standard",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:	0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:21,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient Active",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:5000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:22,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient Intensive",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:7000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:23,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient standard",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:24,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient Active",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:5000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:25,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient Intensive",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:7000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },


        
    {
      id:26,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient standard",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:27,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient Active",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:5000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:28,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Promocja - Klient Intensive",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:7000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:	0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:29,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient standard",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:30,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient Active",
      maxLTV	:	0.9	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:5000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id:31,
      bank:"mbank",
      nazwaOferty:"Kredyt Hipoteczny z oprocentowaniem stałym",
      nazwaPakietu	:"Standard - Klient Intensive",
      maxLTV	:	0.9	,
      kwotaKredytuOd	:1000	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:7000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:7.31,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"3m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:		0.00065/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.00045,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	2	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    
    

    {
      id:35,
      bank:'Alior',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta „M w Wielkim Mieście”",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:30000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.9,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.00096/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.0285,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:36,
      bank:'Alior',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta specjalna Megahipoteka z ubezpieczeniem na życie",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	:30000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.9,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:0.00096/12,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.05,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },


    {
      id:37,
      bank:'Alior',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta bez ubezpieczenia Megahipoteka",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	:10000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.9,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.00096/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:38,
      bank:'Santander',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Klient Wewnętrzny oprocentowanie zmienne",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:20000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	""	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	1	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:39,
      bank:'Santander',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Klient Zewnętrzny oprocentowanie zmienne",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:20000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	1	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:40,
      bank:'Santander',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Klient Wewnętrzny Select oprocentowanie zmienne",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:20000000,
      wymaganeZarobkiNetto	:10000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	""	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	1	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:41,
      bank:' Santander',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Klient Zewnętrzny Select oprocentowanie zmienne",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	:20000000,
      wymaganeZarobkiNetto	:10000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	""	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	1	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:42,
      bank:'Alior',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta standardowa bez ubezpieczenia na życie",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	:10000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.9,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"",
      kosztZBanku	:	""	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:43,
      bank:'Alior',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta standardowa z ubezpieczeniem na życie",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	:10000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.9,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"",
      kosztZBanku	:	""	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0.05,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"tak",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:44,
      bank:'PKOBP',
      nazwaOferty:"	Kredyt hipoteczny - zmienne oprocentowanie",
      nazwaPakietu	:"Standardowa oferta",
      maxLTV	:	0.9	,
      kwotaKredytuOd	:	20000	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	'',
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.5	,
      komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.0008/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0.0033276,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,//pełny
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.5	,
      ubezpieczenieOdUtratyPracy:3.25,
      okresUbezpieczeniaOdUtratyPracy:48,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400	,
      wycenaDom	:	700	,
      wycenaDzialka	:	400	,
      inne	:"",
      inne2:""
    },

    


    {
      id:46,
      bank:'ING',
      nazwaOferty:"	Kredyt hipoteczny - stałe oprocentowanie",
      nazwaPakietu	:"Oferta Standard",
      maxLTV	:	0.8	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 1500000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	1.9	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"nie",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Brak wymogu konta",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	462	,
      wycenaDom	:	748	,
      wycenaDzialka	:	462	,
      inne	:"",
      inne2:""
    },

    {
      id:47,
      bank:'Santander',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Klient Select",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 20000000,
      wymaganeZarobkiNetto	:10000,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	""	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa z obrotem 500zł/mc",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },


    {
      id:48,
      bank:'BPS',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"Oferta Kredyt Mieszkaniowy oprocentowanie okresowo stałe MÓJ DOM",
      maxLTV	:	0.9	,
      kwotaKredytuOd	:	1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.92,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	5,
      marzaPoOkresieStalego	:"",
      prowizja	:	3.5	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"",
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	3	,
      wycenaMieszkanie	:	""	,
      wycenaDom	:	""	,
      wycenaDzialka	: ""	,
      inne	:"",
      inne2:""
    },

    {
      id:49,
      bank:'BPS',
      nazwaOferty:"	Kredyt hipoteczny",
      nazwaPakietu	:"KREDYT HIPOTECZNY MÓJ DOM OFERTA STANDARDOWA",
      maxLTV	:	0.9	,
      kwotaKredytuOd	:	1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.92,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	3.5	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.2	,
      komentarzDoKonta	:"",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"",
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "Brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.2	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	3	,
      wycenaMieszkanie	:	""	,
      wycenaDom	:	""	,
      wycenaDzialka	: ""	,
      inne	:"",
      inne2:""
    },

    {
      id:50,
      bank:'BOŚ Bank',
      nazwaOferty:"Kredyt hipoteczny w Dobrym Stylu - oprocentowanie zmienne",
      nazwaPakietu	:"",
      maxLTV	:	0.8	,
      kwotaKredytuOd	: 1	,
      kwotaKredytuDo	: 5000000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:6.99,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	2.2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"6m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	: "",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      kosztZBanku	:	0.00095/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",//ub dodatkowa obniżka marży o 0.1
      ubezpieczenieNaŻycie	:	0.022,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	: 60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	3	,
      wycenaMieszkanie	:	400,
      wycenaDom	:	600	,
      wycenaDzialka	:	""	,
      inne	:"",
      inne2:""
    },

    {
      id: 51,
      bank:'ING',
      nazwaOferty:"Wakacje na swoim",
      nazwaPakietu	:"Lekka rata",
      maxLTV	:	0.8	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 1500000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.93,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	1.5	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.4	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:36,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.5	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	462	,
      wycenaDom	:	748	,
      wycenaDzialka	:	462	,
      inne	:"",
      inne2:""
    },

    {
      id:52,
      bank:'ING',
      nazwaOferty:"Wakacje na swoim",
      nazwaPakietu	:"Łatwy Start",
      maxLTV	:	0.8	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 1500000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.93,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Zmienne",
      rataRówna : 0,
      staleNa5czy10Lat	:	"",
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.4	,
      komentarzDoKonta	:"Wpływ 2000zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.000096	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0.00035,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:36,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	0.5	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	462	,
      wycenaDom	:	748	,
      wycenaDzialka	:	462	,
      inne	:"",
      inne2:""
    },

    {
      id:53,
      bank:'PKOBP',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Ubezpieczenie na życie",
      maxLTV	:	1	,
      kwotaKredytuOd	:	20000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	0.5	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.5	,
      komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.0008/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	0.0033276,
      ubezpieczenieNaŻycieJakaSkładka: "Miesięcznie",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,//pełny
      czyObowiązkowe	:"Tak",
      rezygnacjaZUb	:	0.5	,
      ubezpieczenieOdUtratyPracy:"",
      okresUbezpieczeniaOdUtratyPracy:"",
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400	,
      wycenaDom	:	700	,
      wycenaDzialka	:	400	,
      inne	:"",
      inne2:""
    },


    {
      id:54,
      bank:'PEKAOSA',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Wariant z prowizją i niższą marżą",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	1.99	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa",
      rezygnacjaZKarty	: 0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      ubNieruchomościpełnykoszt:"",
      kosztZBanku	:	0.001/12	,
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie:	"",
      ubezpieczenieNaŻycieJakaSkładka: "",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:48,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:55,
      bank:'PEKAOSA',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Wariant bez prowizji z wyższą marżą",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"tak",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Konto ROR z wpływem",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"Karta kredytowa",
      rezygnacjaZKarty	: 0.1,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	: "pełny",
      ubNieruchomościpełnykoszt:"",
      kosztZBanku	:	0.001/12	,
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie:	"",
      ubezpieczenieNaŻycieJakaSkładka: "",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:48,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:56,
      bank:'Alior',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Oferta „M w Wielkim Mieście”",
      maxLTV	:	1	,
      kwotaKredytuOd	:	100000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.00096/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.0285,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:57,
      bank:'Alior',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Oferta specjalna Megahipoteka z ubezpieczeniem na życie",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:0.00096/12,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0.05,
      ubezpieczenieNaŻycieJakaSkładka: "Jednorazowo",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:60,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },


    {
      id:58,
      bank:'Alior',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Oferta bez ubezpieczenia Megahipoteka",
      maxLTV	:	1,
      kwotaKredytuOd	:	100000,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	2	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	""	,
      komentarzDoKonta	:"Wpływ wynagrodzenia minimum 1500zł na miesiąc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:0.5,
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:60,
      kosztZBanku	:	0.00096/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:0.1,
      ubezpieczenieNaŻycie	:	0,
      ubezpieczenieNaŻycieJakaSkładka: "brak",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:0,
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	1	,
      ubezpieczenieOdUtratyPracy:0,
      okresUbezpieczeniaOdUtratyPracy:0,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	480	,
      wycenaDom	:	780	,
      wycenaDzialka	:	480	,
      inne	:"",
      inne2:""
    },

    {
      id:59,
      bank:'PKOBP',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Z ubezpieczeniem od utraty pracy",
      maxLTV	:	1	,
      kwotaKredytuOd	:	20000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	0	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.5	,
      komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.0008/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	"",
      ubezpieczenieNaŻycieJakaSkładka: "",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:"",//pełny
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:3.25,
      okresUbezpieczeniaOdUtratyPracy:48,
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400	,
      wycenaDom	:	700	,
      wycenaDzialka	:	400	,
      inne	:"",
      inne2:""
    },

    {
      id:60,
      bank:'PKOBP',
      nazwaOferty:"Bezpieczny Kredyt 2%",
      nazwaPakietu	:"Brak ubezpieczeń",
      maxLTV	:	1	,
      kwotaKredytuOd	:	20000	,
      kwotaKredytuDo	: 600000,
      wymaganeZarobkiNetto	:0,
      dataOfertyOd	:"",
      dataOfertyDo	:"",
      marża	:"",
      marża1Rok	:"",
      wibor:5.97,
      RRSO:"",
      oprocentowanieStaleCzZmienne	:"Stałe",
      rataRówna : 0,
      staleNa5czy10Lat	:	10,
      marzaPoOkresieStalego	:"",
      prowizja	:	1.7	,
      rataPrzejsciowa	:"",
      rataDocelowa	:"",
      całkowityKoszt:"",
      wibor3mCzy6m	:"1m",
      kontoOsobiste	:"tak",
      czyObowiazkowe	:"nie",
      kosztProwadzenia	:"",
      rezygnacjaZKonta	:	0.5	,
      komentarzDoKonta	:"karta debetowa z obrotem 500zł/mc",
      kartaKredytowa	:"",
      czyObowiązkowa	:"",
      kosztKarty	:"",
      rezygnacjaZKarty	:"",
      komentarzDoKartyKedytowej	:"",
      ubezpieczenieNieruchomosci:"Tak",
      naJakiOkresUbN	:"pełny",
      kosztZBanku	:	0.0008/12	,
      ubNieruchomościpełnykoszt:"",
      rezygnacjaZUB	:"",
      ubezpieczenieNaŻycie	:	"",
      ubezpieczenieNaŻycieJakaSkładka: "",
      ubezpieczenieNaŻycieSkładka:"",
      ubezpieczenieNaŻyciepełnyKoszt:"",
      okresUbZycie	:"",//pełny
      czyObowiązkowe	:"nie",
      rezygnacjaZUb	:	""	,
      ubezpieczenieOdUtratyPracy:"",
      okresUbezpieczeniaOdUtratyPracy:"",
      rezygnacjaZUbodUtratyPracy:"",
      wcześniejszaSpłata	:	0	,
      wycenaMieszkanie	:	400	,
      wycenaDom	:	700	,
      wycenaDzialka	:	400	,
      inne	:"",
      inne2:""
    },



    ];
  
    
  
export {tableData,columns}


  
  
  